import React, { useState, useEffect } from "react"

import Alert from 'react-bootstrap/Alert'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Spinner from 'react-bootstrap/Spinner'
import Table from 'react-bootstrap/Table'

import axios from "axios";
import $ from 'jquery';
import './panel.css';
import tabler from './nlp/tabler_adl.js';
import frm from './formAux.js';
import './nlp/tabler.css';

function fitText( o )
{
    o = $(o);
    if( !o.length ) return;
    var max = 3;
    while( o[0].offsetWidth < o[0].scrollWidth && max-- > 0 )
    {
        console.log( 'title', parseInt(o.css('fontSize')), o[0].offsetWidth, o[0].scrollWidth );
        o.css( {fontSize: parseInt(o.css('fontSize'))-2});
    }
}

var tab;

function NlpProjectBrowse(prop) {

    var global = window.GlobalVars;
    function fileClick(ev)
    {
        var o = $(this);
        var fileId = o.prop('fileId');
        console.log( 'FILEID', fileId );
        window.GlobalVars.PDFFileId = fileId;
        window.saveSession( function(){
            window.goPage('nlpAnnotations');
        } );
    }

    function addProject( hook, p )
    {
        var canEdit = (
            (
                p.company == window.GlobalVars.userCompany
                && window.hasPriv( 'c_admin')
            )
            || window.hasPriv('admin')
        );
        console.log( 'addProject', p, canEdit );
        var proj = $('<DIV>').addClass('project-item').prop('title',p.name);
        if( !p.active ) proj.addClass('project-inactive');
        var content = $('<DIV>').addClass('project-content');
        var title = $('<H1>').text(p.name);
        content.append( title );
        proj.append(content);
        var counts = [{label:'Documents',val:p.num_files}];
        for( var k = 0 ; k < window.stateLabels.length ; k++ )
        {
            if( p.states && p.states[k] > 0 )
            {
                counts.push( {label:window.stateLabels[k], val:p.states[k]});
            }
        }
        counts.forEach( c => {
            var ct = $('<p>').html(c.val + ' '+c.label);
            content.append(ct);
        });
        var dates = $('<DIV>').addClass( 'dates').html( 'Updated: '+window.timeFromNow(p.modified));
        content.append( dates );
        var act = $('<DIV>').addClass('state').text(p.active?'active':'inactive');
        content.append( act );
        if( canEdit )
        {
            var edit = $('<DIV>').addClass('project-edit').html('<i class="fa fa-edit"></i>').attr('title','Edit Project');
            content.append( edit )
            edit.on('click', function(ev){
                ev.preventDefault();
                window.GlobalVars.PDFProjectId = p.id;
                window.GlobalVars.PDFProjectTableCtx = null;;
                window.GlobalVars.PDFProjectName = p.name;
                window.GlobalVars.PDFProjectCompany = p.company;
                window.GlobalVars.PDFProjectType = p.type;
                window.saveSession( function(){
                    window.goPage('nlpImport');
                });
                return false;
            })
            var users = $('<DIV>').addClass('project-users').html('<i class="fa fa-users"></i>').attr('title','Edit Users');
            content.append( users )
            users.on('click', function(ev){
                ev.preventDefault();
                window.GlobalVars.PDFProjectId = p.id;
                window.GlobalVars.PDFProjectTableCtx = null;;
                window.GlobalVars.PDFProjectName = p.name;
                window.GlobalVars.PDFProjectCompany = p.company;
                window.GlobalVars.PDFProjectType = p.type;
                window.saveSession( function(){
                    window.goPage('nlpWorkers');
                });
                return false;
            })
        }
        proj.on('click', function(){
            window.GlobalVars.PDFProjectId = p.id;
            window.GlobalVars.PDFProjectTableCtx = null;;
            window.GlobalVars.PDFProjectName = p.name;
            window.GlobalVars.PDFProjectCompany = p.company;
            window.GlobalVars.PDFProjectType = p.type;
            window.GlobalVars.PDFRole = null;
            window.saveSession( function(){
                window.goPage('nlpBrowse');
            });
        })
        hook.append(proj);
        fitText( title );

    }

    useEffect( function(a){
        $('#topbuttons').html('');
        if( window.hasPriv( 'admin', 'c_admin') )
        {
            var addBut = $('<Button id="addProject" variant="primary" type="submit" class="mt-2 btn btn-primary"><i class="fa fa-plus mr-2"></i>Create New Project</Button>')
            addBut.on('click', () => {
                window.GlobalVars.PDFProjectId = null;
                window.GlobalVars.PDFProjectCompany = null;
                window.GlobalVars.PDFProjectName = null;
                window.GlobalVars.PDFProjectActive = false;
                window.GlobalVars.PDFProjectType = null;
                window.GlobalVars.PDFProjectTableCtx = null;
                window.GlobalVars.PDFProjectTypeCheck = null;
                window.GlobalVars.PDFFileId = null;
                window.saveSession( function(){
                    window.goPage('nlpImport');
                });
            })
            $('#topbuttons').append(addBut);
            // frm.paginator( $('#topbuttons'), 1, 15, console.log  )
        }
        var match = {active:true};
        console.log( 'MATCH', {match:match})
        window.post( 'find_projects', {match:match}, function(res){
            console.log( 'PDFS', res.data );
            var projects = res.data.records;
            var annotations = [];
            var results = $('#results').html('');
            // console.log( 'PROJECTS', projects );
            if( !projects.length )
            {
                $('.alert').remove();
                var empty = $('<div role="alert" class="fade alert alert-danger show">').html('No projects found');
                $('#topbuttons').prepend(empty);
                return;
            }
            var allStates = {};
            projects.forEach( p => {
                if( p.states )
                {
                    for( var k in p.states )
                    {
                        allStates[k] = (allStates[k] ||0)+1;
                        p['state_'+k] = p.states[k];
                    }
                    // counts.push( {label:window.stateLabels[k], val:p.states[k]});
                }
                // addProject( results, p );
            })
            console.log( 'allStates', allStates );
            // return;
            var desc = {
                title: 'Projects',
                columns: {
                    name: 'Name',
                    companyName: 'Company',
                    ltype: 'Type',
                },
                filter: true,
                search: true,
                sort: true,
                initialSort: 'modified',
                initialSortDir: -1,
                pageSize: 10,
                noFilter: {
                    state_0:1,
                    state_1:1,
                    state_2:1,
                    state_3:1,
                    state_4:1,
                    state_5:1,
                    state_6:1,
                    state_7:1,
                    state_8:1,
                    modified:1,
                },
                noSort: null,
                centerCol: ['state_0','state_1','state_2','state_3','state_4','state_5','state_6','state_7','state_8','state','modified','active'],
				format: tabler.formatString,
				forceType: {
                    state_0:1,
                    state_1:1,
                    state_2:1,
                    state_3:1,
                    state_4:1,
                    state_5:1,
                    state_6:1,
                    state_7:1,
                    state_8:1,
                    modified:1,
                },
                colWidth: {
                    name: 20,
                    state_0:5,
                    state_1:5,
                    state_2:5,
                    state_3:5,
                    state_4:5,
                    state_5:5,
                    state_6:5,
                    state_7:5,
                    state_8:5,
                },
				formatCol:{
					modified: tabler.formatTimeAgoSec,
					state: tabler.formatState,
                    active: tabler.formatActive,

                    ltype: function(value) {
                        let style = '';
                            console.log('value..', value);
                        switch (value) {
                            
                            case 'Bulk Image Classification':
                                style = 'color: #36c76c; background-color: #EBFAF0; padding: 2px 4px; border-radius: 8px;';
                                break;
                            case 'Classification':
                                style = 'color: #00d1cc; background-color: #cffffe; padding: 2px 4px; border-radius: 8px;';
                                break;
                            case 'Comprehend NER(Experimental)':
                                style = 'color: #ff007c; background-color: #ffe3f1; padding: 2px 4px; border-radius: 8px;';
                                break;
                            case 'Media Transcription':
                                style = 'color:#007bff; background-color: #0090ff2e; padding: 2px 4px; border-radius: 8px;';
                                break;
                            case 'AmEx Audio Templete':
                                style = "color: #0ea5e9; border: 1px solid #0ea5e9; background-color: white; padding: 2px 8px; border-radius: 6px; font-weight: 500;";
                                break;
                            case 'Code Switching':
                                style = "color: #0ea5e9; border: 1px solid #0ea5e9; background-color: white; padding: 2px 8px; border-radius: 6px; font-weight: 500;";
                                break;
                            case 'NER':
                                style = 'color: #6e67ff; background-color: #DDDBFF; padding: 2px 4px; border-radius: 8px;';
                                break;
                            case 'OCR':
                                style = 'color: #ff6692; background-color: #ffccdb; padding: 2px 4px; border-radius: 8px;';
                                break;
                            case 'Object Detection':
                                style = 'color: #f8c20a; background-color: #fff9e5; padding: 2px 4px; border-radius: 8px;';
                                break;
                            case 'Q&A':
                                style = 'color: #f124ff; background-color: #fee5ff; padding: 2px 4px; border-radius: 8px;';
                                break;
                            case 'Segmentation':
                                style = 'color: #c400b3; background-color: #f5e5f4; padding: 2px 4px; border-radius: 8px;';
                                break;
                            case 'Bounding Box':
                                style = 'color: #000; background-color: #d7fbf3; padding: 2px 4px; border-radius: 8px;';
                                break;
                            case 'Key Point':
                                style = 'color: #000; background-color: #e2f5cc; padding: 2px 4px; border-radius: 8px;';
                                break;
                            case 'Post-estimation':
                                style = 'color: #000; background-color: #F8ECBC; padding: 2px 4px; border-radius: 8px;';
                                break; 
                            case 'Content Generation':           
                                style = 'color:rgb(0, 0, 0); background-color:rgb(245, 247, 181); padding: 2px 4px; border-radius: 8px;';            
                                 break;                          
                            default:
                                style = 'color: black; background-color: white;'; 
                                break;
                        }
            
                        return `<span style="${style}">${value}</span>`; 
                    }
				}
                // clickCol: ['stateLabel','source'],
            }
            if( !window.hasPriv('admin')) delete desc.columns.companyName;

            var stateCols = [];
            window.stateLabelsAbv.forEach( (s,i) => {
                if( allStates[i] ) stateCols.push({i:i,l:s})
            });
            console.log( 'stateCols', stateCols );
            for( var s of stateCols )
            {
                desc.columns['state_'+s.i] = s.l;
                // desc.columns['state_'+s.i] = 'Adj.';
            }
            desc.columns.modified = 'Updated';
            // desc.columns.active = 'Active'
            console.log( 'DESC', desc )
            tab = tabler.table($('#documentlist'), desc, 'projects' );
            projects.forEach( a => {
                a.ltype = window.ProjectTypes[a.type];
                // console.log('a_b', a.ltype)
                // console.log( 'addproj', a )
                tab.addRow(a, function( col, row ){
                    console.log( 'tabler clickkkkk', col, row, row[col] )
                    var p = row;
                    window.GlobalVars.PDFProjectId = p.id;
                    window.GlobalVars.PDFProjectTableCtx = null;;
                    window.GlobalVars.PDFProjectName = p.name;
                    window.GlobalVars.PDFProjectCompany = p.company;
                    window.GlobalVars.PDFProjectActive = p.active;
                    window.GlobalVars.PDFProjectType = p.type;
                    window.GlobalVars.PDFRole = null;
                    tabler.clearCtx('tasks');
                    tabler.clearCtx('workers');
                    window.saveSession( function(){
                        window.goPage('nlpBrowse',window.projectParams(p));
                    });
                    // fileClickTabler( col, row )
                })
            });
            tab.draw();

        });
    });

    return (
        <div fluid="md p-0" className="maincontent">
            <div id="topbuttons"></div>

            <Table id="documentlist" bordered hover size="sm" className="table-grid mt-3">
            </Table>
            <div id="results" className="project-browse">
            </div>
        </div>

    )
}

export default NlpProjectBrowse
